import * as React   from "react";
import ReactTooltip from 'react-tooltip';

import "./company-info-route.scss";

import {cs}                  from "@Common/react/chain-services";
import {consumeContext}      from "@Common/react/context";
import {Responsive}          from "@Common/ui-components/responsive";

import {InternalLink} from "@Xpresso/routes/common/components/internal-link";

import {CompanyLayout}       from "../common/company-layout";
import {MultiInputModal}     from "../../common/multi-input-modal/multi-input-modal";
import {PasswordUpdateModal} from "../../common/password-update-modal/password-update-modal";

export const AccountCompanyInfoRoute = () => cs(
    ({}, next) => CompanyLayout({activeTab: "company-info", next}),
    consumeContext("apis"),
    consumeContext("company"),
    consumeContext("userLevels"),
    consumeContext("routerHistory"),
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ["generalData", ({company}, next) => next(company && parseCompanyData({company}))],
    ["generalModal", ({company, responsive, apis}, next) => MultiInputModal({
        next,
        title: "General Information",
        labelLocation: responsive.lt("mobile") ? "top" : "left",
        onSave: (updateFields) => (apis.next.session.updateCompany({updateFields})),
        reload: () => company?.reload(),
        urlParam: "general",
    })],
    ["customizationData", ({company}, next) => next(company && parseCompanyDisplayData({company}))],
    ["customizationModal", ({company, responsive, apis}, next) => MultiInputModal({
        next,
        title: "Company Contact Information",
        labelLocation: responsive.lt("mobile") ? "top" : "left",
        onSave: (updateFields) => (apis.next.session.updateCompany({updateFields})),
        reload: () => company?.reload(),
        urlParam: "contact",
    })],
    ["managePasswordModal", ({apis, company}, next) => PasswordUpdateModal({
        next,
        title: "Manage Company Password",
        onSave: apis.next.userProfile.updateUserProfile,
        targetUserId: company?.idUser,
        urlParam: "password",
    })],
    ({generalModal, generalData, customizationModal, customizationData, managePasswordModal, company, userLevels}) => (
        !company ? (
            <div className="company-info-route-x0y">
                <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                    Loading...
                </div>
            </div>
        ) : company?.idCompany ? (
            <div className="company-info-route-x0y">
                <ReactTooltip  id="company-info-route" place="bottom" delayShow={100}/>
                <div className="section">
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="General Information">
                            General Information
                        </div>
                        <a className="edit" xd-qa-type="link" xd-qa-name="Edit General Information" onClick={() => generalModal.show({data: generalData})}>
                            Edit
                        </a>
                    </div>
                    {generalInfo({company}) && <div className="card">
                        <div className="title" xd-qa-type="label" xd-qa-name="Company Name">
                            {company.companyName}
                        </div>
                        <div className="item">
                            <div className="label">
                                {company.companyPhone1 &&
                                <span className="value" xd-qa-type="label" xd-qa-name="Company Phone 1" data-for="company-info-route" data-tip={company.companyPhone1}>
                                    {company.companyPhone1}
                                </span>}
                                {company.companyPhone1 && company.companyPhone2 && " | "}
                                {company.companyPhone2 &&
                                <span className="value" xd-qa-type="label" xd-qa-name="Company Phone 2" data-for="company-info-route" data-tip={company.companyPhone2}>
                                    {company.companyPhone2}
                                </span>}
                            </div>
                            <div className="label">
                            <span className="value" xd-qa-type="label" xd-qa-name="Company Email" data-for="company-info-route" data-tip={company.companyEmail}>
                                    {company.companyEmail}
                                </span>
                            </div>
                        </div>

                        <div className="vertical-split">
                            <div className="item">
                                <div className="label" xd-qa-type="label" xd-qa-name="Manager">
                                    {company.companyManagerName || company.companyManagerPhone || company.companyManagerEmail ? "Manager" : ""}
                                </div>
                                <div className="value name" xd-qa-type="label" xd-qa-name="Company Manager Name" data-for="company-info-route" data-tip={company.companyManagerName}>
                                    {company.companyManagerName}
                                </div>
                                <div className="value" xd-qa-type="label" xd-qa-name="Company Manager Phone" data-for="company-info-route" data-tip={company.companyManagerPhone}>
                                    {company.companyManagerPhone}
                                </div>
                                <div className="value" xd-qa-type="label" xd-qa-name="Company Manager Email" data-for="company-info-route" data-tip={company.companyManagerEmail}>
                                    {company.companyManagerEmail}
                                </div>
                            </div>
                            <div className="item">
                                <div className="label" xd-qa-type="label" xd-qa-name="Admin">
                                    {company.companyAdminName1 || company.companyAdminPhone1 || company.companyAdminEmail1 ? "Admin" : ""}
                                </div>
                                <div className="value name" xd-qa-type="label" xd-qa-name="Company Admin Name" data-for="company-info-route" data-tip={company.companyAdminName1}>
                                    {company.companyAdminName1}
                                </div>
                                <div className="value" xd-qa-type="label" xd-qa-name="Company Admin Phone" data-for="company-info-route" data-tip={company.companyAdminPhone1}>
                                    {company.companyAdminPhone1}
                                </div>
                                <div className="value" xd-qa-type="label" xd-qa-name="Company Admin Email" data-for="company-info-route" data-tip={company.companyAdminEmail1}>
                                    {company.companyAdminEmail1}
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
                <div className="section">
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="Company Contact Information">
                            Company Contact Information
                        </div>
                        <a className="edit" xd-qa-type="link" xd-qa-name="Edit Customization Information" onClick={() => customizationModal.show({data: customizationData})}>
                            Edit
                        </a>
                    </div>
                    {contactInfo({company}) && (company["companyAddress1"] || company["companyAddress2"] || company["companyCity"] || company["companyState"] || company["companyZip"] || company["companySupportPhone"]) &&
                        <div className="card">
                            <div className="value" xd-qa-type="label" xd-qa-name="Company Address 1" data-for="company-info-route" data-tip={company["companyAddress1"]}>
                                {company.companyAddress1}
                            </div>
                            {company.companyAddress2 &&
                            <div className="value" xd-qa-type="label" xd-qa-name="Company Address 2" data-for="company-info-route" data-tip={company["companyAddress2"]}>
                                {company.companyAddress2}
                            </div>}
                            <div className="value" xd-qa-type="label" xd-qa-name="Company City And State" data-for="company-info-route" data-tip={company["companyCity"]}>
                                {company.companyCity} {company.companyCity && company.companyState && ", "} {company.companyState}
                            </div>
                            <div className="value" xd-qa-type="label" xd-qa-name="Company Zip" data-for="company-info-route" data-tip={company["companyZip"]}>
                                {company.companyZip}
                            </div>
                        </div>
                    }
                </div>
                {company?.idUser && (
                    <div className="section">
                        <div className="header">
                            <div className="title" xd-qa-type="label" xd-qa-name="Manage Company Password">
                                Manage Company Password
                            </div>
                            <a className="edit" xd-qa-type="link" xd-qa-name="Edit Password" onClick={() => managePasswordModal.show()}>
                                Edit
                            </a>
                        </div>
                        {userLevels?.isGeneric === false && (
                            <div className="sub-title" xd-qa-type="label" xd-qa-name="Profile Password Helper Text">
                                Reset password for this shared company account. To update your personal password,&nbsp;
                                <InternalLink to="/account/my-profile" xd-qa-type="link" xd-qa-name="click here">click here</InternalLink>
                            </div>
                        )}
                    </div>
                )}
                {/* Quackathon Project Needs CPREF to implement
                <div className="section">
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="Manage Company Password">
                            Manage Company Scheme
                        </div>
                        <a className="edit" xd-qa-type="link" xd-qa-name="Edit Password" onClick={() => routerHistory.push(`/?edit=scheme`)}>
                            Edit
                        </a>
                    </div>
                </div> */}
            </div>
        ) : (
            <div className="company-info-route-x0y" xd-qa-type="label" xd-qa-name="Invalid Login Level">
                {"Must be logged in as Company to view this page"}
            </div>
        )
    )
);

export const parseCompanyData = ({company}) => {
    return [
        {"label": <div>Name</div>, "value": company.companyName, "mapping": "companyName", "maxLength": 80},
        {"label": "Manager", "value": company.companyManagerName, "mapping": "companyManagerName", "maxLength": 40},
        {"label": "Manager Phone", "value": company.companyManagerPhone, "mapping": "companyManagerPhone", "maxLength": 25},
        {"label": <div>Manager Email</div>, "value": company.companyManagerEmail, "mapping": "companyManagerEmail", "maxLength": 60},
        {"label": "Admin Name", "value": company.companyAdminName1, "mapping": "companyAdminName1", "maxLength": 40},
        {"label": "Admin Phone", "value": company.companyAdminPhone1, "mapping": "companyAdminPhone1", "maxLength": 40},
        {"label": "Admin Email", "value": company.companyAdminEmail1, "mapping": "companyAdminEmail1", "maxLength": 60},
        {"label": "Company Phone 1", "value": company.companyPhone1, "mapping": "companyPhone1", "maxLength": 40},
        {"label": "Company Phone 2", "value": company.companyPhone2, "mapping": "companyPhone2", "maxLength": 60},
        {"label": "Company Email", "value": company.companyEmail, "mapping": "companyEmail", "maxLength": 60},
    ]
};

export const parseCompanyDisplayData = ({company}) => {
    return [
        {"label": "Address 1", "value": company.companyAddress1, "mapping": "companyAddress1", "maxLength": 80},
        {"label": "Address 2", "value": company.companyAddress2, "mapping": "companyAddress2", "maxLength": 80},
        {"label": "City", "value": company.companyCity, "mapping": "companyCity", "maxLength": 80},
        {"label": "State", "value": company.companyState, "mapping": "companyState", "maxLength": 80},
        {"label": "Zip Code", "value": company.companyZip, "mapping": "companyZip", "maxLength": 80},
    ]
};

export const generalInfo = ({company}) => {
    return company.companyName ||
    company.companyPhone1 ||
    company.companyPhone2 ||
    company.companyEmail ||
    company.companyManagerName ||
    company.companyManagerPhone ||
    company.companyManagerEmail ||
    company.companyAdminName1 ||
    company.companyAdminPhone1 ||
    company.companyAdminEmail1;
}

export const contactInfo = ({company}) => {
    return company.companyAddress1 ||
    company.companyAddress2 ||
    company.companyCity ||
    company.companyState ||
    company.companyZip;
}
